<template>
    <div v-loading="loading" style="margin-top: 10px">
        <div class="form-box">
            <el-form ref="form" inline :model="queryForm" label-width="80px" style="text-align: center">
                <el-form-item>
                    <el-input v-model="queryForm.name" clearable placeholder="Name"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-input v-model="queryForm.phone" clearable  placeholder="Phone"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-input v-model="queryForm.chequeNo" clearable  placeholder="Cheque No"></el-input>
                </el-form-item>

                <el-form-item>
                    <el-date-picker
                            clearable
                            v-model="queryForm.created"
                            type="daterange"
                            format="dd-MM-yyyy"
                            value-format="yyyy-MM-dd"
                            start-placeholder="Request Start Date"
                            end-placeholder=" Request End Date">
                    </el-date-picker>
                </el-form-item>

                <el-form-item>
                    <el-date-picker
                            clearable
                            v-model="queryForm.completed"
                            style="width: 380px"
                            type="daterange"
                            format="dd-MM-yyyy"
                            value-format="yyyy-MM-dd"
                            start-placeholder="Completed Start Date"
                            end-placeholder="Completed End Date">
                    </el-date-picker>
                </el-form-item>

                <el-form-item>
                    <el-select v-model="queryForm.status" placeholder="Withdrawal Status" clearable>
                        <el-option
                                v-for="item in [{value:1,label:'Pending'},{value:2,label:'Cheque Issued'}]"
                                :key="item.value + item.label "
                                :label="item.label"
                                :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-button type="primary" @click="loadData" icon="el-icon-search" size="medium" circle></el-button>
                <el-button type="primary" @click="exportData" icon="el-icon-download" size="medium" circle></el-button>
            </el-form>
        </div>

        <el-table
                fit
                stripe
                highlight-current-row
                class="data-table"
                :data="data">
            <el-table-column
                    header-align="center"
                    align="center"
                    v-for="item in [
                        {prop:'paymentBid',label:'Ref No.',wth:'160px'},
                        {prop:'userName',label:' User Name',wth:'200px'},
                        {prop:'phone',label:'Phone',wth:'160px'},
                        {prop:'created',label:'Request Date',fmt:selfTimeFormat,wth:'180px'},
                        {prop:'bank',label:'Bank',wth:'160px'},
                        {prop:'bankAccount',label:'Bank Account',wth:'170px'},
                        {prop:'amount',label:'Amount',wth:'160px'},
                        {prop:'status',label:'Withdrawal Status',fmt:statusFmt,wth:'150px'},
                        {prop:'chequeNo',label:'Cheque No',wth:'160px'},
                        {prop:'completed',label:'Completed Date',fmt:selfTimeFormat,wth:'150px'},
                    ]"
                    :formatter="item.fmt"
                    :width="item.wth"
                    :prop="item.prop"
                    :label="item.label"
                    :key="item.label">
            </el-table-column>

            <el-table-column
                    header-align="center"
                    label="Action"
                    width="150px"
                    align="center">
                <template slot-scope="s">
                    <el-button type="warning" size="mini" v-if="s.row.status ===1" @click="openEdit(s.row)">
                        Issued Cheque
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="page">
            <el-pagination @current-change="loadData"
                           :page-size="page.size"
                           :current-page.sync="page.page"
                           :page-count="page.totalPage"
                           layout="prev, pager, next"
                           :total="data.total">
            </el-pagination>
        </div>

        <el-dialog
                v-if="dialogVisible"
                center
                :visible.sync="dialogVisible"
                width="40%">
            <el-form ref="form" :model="form" :rules="rules" label-width="120px">
                <el-form-item prop="chequeNo" label="Cheque No">
                    <el-input v-model="form.chequeNo" placeholder="Enter cheque no."></el-input>
                </el-form-item>
            </el-form>

            <span slot="footer">
                <el-button type="primary" @click="saveData">Confirm</el-button>
                <el-button @click="dialogVisible = false">Cancel</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {walletWithdraws, doWalletWithdraws,walletWithdrawsExport} from '@/api/eazableAPI'
    import {excelRequestRequest} from "@/utils/ApiUtils";

    export default {
        name: "WithDraw",
        data: function () {
            return {
                dialogVisible: false,
                isCreate: false,
                form: {},
                loading: false,
                queryForm: {},
                data: [],
                page: {'page': 1, 'size': 10, 'totalPage': 1, 'total': 0},
                rules: {
                    chequeNo: [
                        {required: true, message: 'Please input the cheque no.', trigger: 'blur'},
                    ],
                }
            }
        },
        methods: {
            loadData() {
                this.$pageUtils(this, walletWithdraws)
            },
            statusFmt(row, cell, val) {
                return val === 1 ? 'Pending' : 'Cheque Issued'
            },
            openEdit(data) {
                this.form = this.$copy(data)
                this.dialogVisible = true
            },
            exportData() {
                excelRequestRequest(this, walletWithdrawsExport);
            },
            saveData() {
                const action = doWalletWithdraws
                this.$refs['form'].validate((valid) => {
                    const form = {
                        chequeNo: this.form.chequeNo,
                        id: this.form.id
                    }
                    if (valid) {
                        action(form)
                            .then(() => {
                                this.loadData()
                                this.dialogVisible = false
                            })
                    }
                })
            }
        },
        mounted() {
            this.loadData()
        }
    }
</script>

<style scoped>

</style>
